import { doc, DocumentReference, serverTimestamp, Timestamp, updateDoc } from 'firebase/firestore'
import medicalReimbursementServiceConfigs from './configs'
import { db } from '../../firebase/firebase'
import { MedicalReimbursement, MedicalReimbursementRaw } from '../../database/tables'
import DateHelper from '../../helpers/date-helper'

export type UpdateMedicalReimbursementByIdParams = {
  id: string
  data: Partial<
    Omit<
      MedicalReimbursement,
      | 'id'
      | 'approvalStatus'
      | 'createdAt'
      | 'updatedAt'
      | 'updatedBy'
      | 'approvalUpdatedAt'
      | 'approvalBy'
      | 'supportingDocumentRef'
      | 'supportingDocumentUrl'
    >
  >
  updatedBy: string | null
}

export default async function updateMedicalReimbursementById(
  params: UpdateMedicalReimbursementByIdParams,
): Promise<void> {
  return new Promise(async (resolve, reject) => {
    try {
      const docRef = doc(
        db,
        medicalReimbursementServiceConfigs.collectionName,
        params.id,
      ) as DocumentReference<MedicalReimbursementRaw>

      let newServiceDate: { date: Timestamp; stringDate: string } | undefined = undefined

      if (!!params.data.serviceDate) {
        newServiceDate = {
          date: Timestamp.fromDate(params.data.serviceDate),
          stringDate: DateHelper.toLocalDateString(params.data.serviceDate),
        }
      }

      await updateDoc(docRef, {
        ...params.data,
        serviceDate: newServiceDate?.date ?? undefined,
        serviceDateString: newServiceDate?.stringDate ?? undefined,
        updatedBy: params.updatedBy,
        updatedAt: serverTimestamp(),
      })

      return resolve()
    } catch (e) {
      return reject(e)
    }
  })
}
